import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../images/logo.png';

function AdminSideMenu() {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path;

  const navigate = useNavigate();
  
  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove token from localStorage on logout
    navigate('/'); // Redirect to Home page after logout
  };

  return (
    <div
      id="sidebar-wrapper"
      data-simplebar=""
      data-simplebar-auto-hide="true"
    >
      <div className="brand-logo">
        <Link to="/dashboard">
          <img src={Logo} alt="Learning Aids" />
        </Link>
      </div>
      <ul className="sidebar-menu do-nicescrol">
        <li className="sidebar-header">MAIN NAVIGATION</li>

        <li className={isActive('/dashboard') ? 'active' : ''}>
          <Link to="/dashboard" className="wave-effect">
            <i className="icon-home"></i> <span>Dashboard</span>
          </Link>
        </li>
        <li className={isActive('/dashboard/media-library') ? 'active' : ''}>
          <Link to="/dashboard/media-library" className="wave-effect">
            <i className="fa fa-film"></i> <span>Media</span>
          </Link>
        </li>
        

        <li className={isActive('/dashboard/chatbotai-quizzes') ? 'active' : ''}>
          <Link to="/dashboard/chatbotai-quizzes" className="wave-effect">
            <i className="fa fa-tasks"></i> <span>ChatBot Quizzes</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/courses') ? 'active' : ''}>
          <Link to="/dashboard/courses" className="wave-effect">
            <i className="fa fa-book"></i> <span>Courses</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/quizzes') ? 'active' : ''}>
          <Link to="/dashboard/quizzes" className="wave-effect">
            <i className="fa fa-tasks"></i> <span>Quizzes</span>
          </Link>
        </li>


        <li className={isActive('/dashboard/transcripts') ? 'active' : ''}>
          <Link to="/dashboard/transcripts" className="wave-effect">
            <i className="fa fa-tasks"></i> <span>Transcripts</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/students') ? 'active' : ''}>
          <Link to="/dashboard/students" className="wave-effect">
            <i className="fa fa-user"></i> <span>Students</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/calendar') ? 'active' : ''}>
          <Link to="/dashboard/calendar" className="wave-effect">
            <i className="icon-calendar"></i> <span>Calendar</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/profile') ? 'active' : ''}>
          <Link to="/dashboard/profile" className="wave-effect">
            <i className="icon-user"></i> <span>Profile</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/messages') ? 'active' : ''}>
          <Link to="/dashboard/messages" className="wave-effect">
            <i className="fa fa-envelope-open"></i> <span>Messages</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/settings') ? 'active' : ''}>
          <Link to="/dashboard/settings" className="wave-effect">
            <i className="icon-settings"></i> <span>Settings</span>
          </Link>
        </li>

        <li>
          <Link to="/" className="wave-effect" onClick={handleLogout}>
            <i className="fa fa-sign-out"></i> <span>Logout</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default AdminSideMenu;
